(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["proshunter-variant-thumbs"] && !Shopify.designMode) return;
  try {
    document.addEventListener('pointerover', function (e) {
    var a = e.target.closest && e.target.closest('.ph-vthumb[data-src]');
    if (!a) return;
    var card = a.closest('product-card') || a.closest('.product-card');
    var img = card && card.querySelector('.card-gallery img');
    if (!img) return;
    if (img.dataset.phOrig === undefined) { img.dataset.phOrig = img.getAttribute('src') || ''; img.dataset.phOrigSrcset = img.getAttribute('srcset') || ''; }
    img.srcset = a.dataset.srcset; img.src = a.dataset.src;
  });
  document.addEventListener('pointerout', function (e) {
    var wrap = e.target.closest && e.target.closest('.ph-vthumbs');
    if (!wrap) return;
    if (e.relatedTarget && wrap.contains(e.relatedTarget)) return;
    var card = wrap.closest('product-card') || wrap.closest('.product-card');
    var img = card && card.querySelector('.card-gallery img');
    if (img && img.dataset.phOrig !== undefined) { img.srcset = img.dataset.phOrigSrcset; img.src = img.dataset.phOrig; }
  });
  } catch(e) { console.error(e); }
})();

})();
